import BaseInfForm from "../baseInfForm";
import { useTranslation } from "react-i18next";
import UpdateFormHead from "components/subHead/updateFromHead";
import useMultiLangStore from "store/multiLang";
import {
  CREATE_ADDINF_FORM_ID_ROOM_OPTION,
  CREATE_BASE_FORM_ID_ROOM_OPTION,
} from "components/constent";
import { useGetData } from "../service";
import MultilingualForm from "../multilingualForm";
import MultiFormHead from "components/subHead/multiFormHead";
import { useEditedLang, useSetBaseInf } from "../handlers";
import { useOptionAddInfContext } from "../context";
import i18n from "locales/i18n";

type IAddInfForm = {
  multiLang: string;
};

const OptionCreate = () => {
  const { t } = useTranslation();
  const { getDefaultValue } = useOptionAddInfContext();
  const multiLang = useMultiLangStore((state) => state.multiLang);

  const { baseInf, addInf } = useGetData({ modalNm: "create" });
  const baseValue = getDefaultValue(multiLang) || {};

  const { setBasetInf } = useSetBaseInf();
  const { editedLang } = useEditedLang();

  const savedLangs =
    addInf.length !== 0 ? addInf.map((inf: any) => inf.langCd) : [];

  return (
    <>
      {/* 기본정보 */}
      <UpdateFormHead
        title={t("row_ttl_default")}
        btnTxt="btn_regi_cmm"
        sub={t("sub_require")}
        formId={CREATE_BASE_FORM_ID_ROOM_OPTION}
        btnVisible={!baseInf?.opRgSeq}
      />
      {!baseInf && (
        <BaseInfForm
          baseInf={undefined}
          formId={CREATE_BASE_FORM_ID_ROOM_OPTION}
          formTyp="create"
        />
      )}
      {baseInf && (
        <BaseInfForm
          baseInf={baseInf ?? undefined}
          formId={CREATE_BASE_FORM_ID_ROOM_OPTION}
          formTyp="create"
        />
      )}

      {/* 추가정보 */}
      {baseInf?.opRgSeq && (
        <>
          <MultiFormHead
            title={t("row_ttl_add_inf")}
            formId={CREATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + multiLang}
            savedLangs={savedLangs}
            setBasetInf={setBasetInf}
            editedLang={editedLang}
          />
          {addInf.length !== 0 && (
            <>
              {addInf.map((inf: any) => {
                return (
                  <MultilingualForm
                    inf={
                      inf.langCd === multiLang
                        ? {
                            ...inf,
                            ...baseValue,
                          }
                        : inf
                    }
                    updateAble="true"
                    formTyp={"read"}
                    formId={CREATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + multiLang}
                  />
                );
              })}
            </>
          )}

          {/* Base i18n.language 언어폼  */}
          {!multiLang && savedLangs.length === 0 && (
            <MultilingualForm
              inf={{
                langCd: i18n.language,
                ...baseValue,
              }}
              formTyp={"create"}
              formId={CREATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + multiLang}
            />
          )}
          {/* 언어버튼 클릭 시 폼 추가 */}
          {!!multiLang && !savedLangs.includes(multiLang) && (
            <MultilingualForm
              inf={{
                langCd: multiLang,
                ...baseValue,
              }}
              formTyp={"create"}
              formId={CREATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + multiLang}
            />
          )}
        </>
      )}

      {/* {baseInf && ( */}
      <>
        {/* <UpdateFormHead
          title={t("row_ttl_add_inf")}
          btnTxt="btn_regi_cmm"
          sub={t("sub_require")}
          formId={CREATE_ADDINF_FORM_ID_ROOM_OPTION + "-" + multiLang}
        /> */}

        {/* {langs.map((lang) => {
          return (
            <BaseAddInfForm
              key={lang.code}
              inf={{ langCd: lang.code }}
              formTyp={"create"}
            />
          );
        })} */}
      </>
      {/* )} */}
    </>
  );
};

export default OptionCreate;
